import { render, staticRenderFns } from "./ManagedServices.vue?vue&type=template&id=0bb35822&scoped=true&"
import script from "./ManagedServices.vue?vue&type=script&lang=js&"
export * from "./ManagedServices.vue?vue&type=script&lang=js&"
import style0 from "./ManagedServices.vue?vue&type=style&index=0&id=0bb35822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb35822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
